import { z } from "zod";

export const loginFormSchema = z.object({
  username: z.string().min(1, "Gebruikersnaam is verplicht"),
  password: z.string().min(1, "Wachtwoord is verplicht"),
});

export type LoginFormData = z.infer<typeof loginFormSchema>;